 
import { Route } from 'vue-router'
 
const checkToken = (to, from, next) => {
  if (localStorage.getItem('userToken') === null) {
    next()
    return
  }
  next({ name: 'VideoTour' })
}

const requireAuth = (to, from, next) => {
  if (localStorage.getItem('userToken')) {
    next()
    return
  }
  next({ name: 'LandingPage' })
}

export {
  requireAuth,
  checkToken
}
